import { cn } from '#app/utils/misc'

export interface GlossaryCompareItem {
	label: string
	title: string
	description: string
	bullets?: string[]
}

export interface GlossaryCompareProps {
	eyebrow?: string
	title?: string
	subtitle?: string
	left: GlossaryCompareItem
	right: GlossaryCompareItem
	background?: 'default' | 'muted' | 'primary-light'
}

export function GlossaryCompare({
	eyebrow,
	title,
	subtitle,
	left,
	right,
	background = 'default',
}: GlossaryCompareProps) {
	const bgClasses = {
		default: 'bg-background',
		muted: 'bg-muted/30',
		'primary-light': 'bg-primary/5',
	}

	return (
		<section className={cn('py-16 md:py-20', bgClasses[background])}>
			<div className="container mx-auto px-4">
				{(eyebrow || title || subtitle) && (
					<div className="mx-auto mb-10 max-w-3xl text-center">
						{eyebrow && <p className="text-label text-primary">{eyebrow}</p>}
						{title && <h2 className="text-title-2 mt-3">{title}</h2>}
						{subtitle && (
							<p className="text-muted-foreground mt-4 text-base md:text-lg">
								{subtitle}
							</p>
						)}
					</div>
				)}

				<div className="grid gap-6 lg:grid-cols-2">
					{[left, right].map((item) => (
						<article
							key={item.label}
							className="bg-card border-border rounded-2xl border p-6 shadow-sm"
						>
							<p className="text-label text-primary">{item.label}</p>
							<h3 className="text-title-3 mt-3">{item.title}</h3>
							<p className="text-muted-foreground mt-3 text-sm leading-6 md:text-base">
								{item.description}
							</p>
							{item.bullets?.length ? (
								<ul className="mt-5 space-y-2">
									{item.bullets.map((bullet, index) => (
										<li
											key={`${item.label}-${index}`}
											className="text-foreground text-sm leading-6"
										>
											{bullet}
										</li>
									))}
								</ul>
							) : null}
						</article>
					))}
				</div>
			</div>
		</section>
	)
}
